// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1riNz","header":"ClearentDisclaimer_header__2JusV","inner":"ClearentDisclaimer_inner__2zF0n"};